module.exports = "https://static.wmbcdn.com/uniweb/images/6a24309e40f34a3d65b842c52cfac56c.svg";